import React from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import BannerImag from '../../../Assets/images/cultured-img/landing-page-img/engagment-static-page-img/banner_img.png'
import LineImg from '../../../Assets/images/cultured-img/landing-page-img/engagment-static-page-img/line_1.png'
import IconImg1 from '../../../Assets/images/cultured-img/landing-page-img/engagment-static-page-img/eng-icon1.png'
import IconImg2 from '../../../Assets/images/cultured-img/landing-page-img/engagment-static-page-img/eng-icon2.png'
import IconImg3 from '../../../Assets/images/cultured-img/landing-page-img/engagment-static-page-img/eng-icon3.png'
import { NavLink } from 'react-router-dom'


const EngagementRings = () => {
    return (
        <div className='dfl_e_engament_ring_section'>
            <Container className='dfl_custome_container_staticpage custome_one_Container '>
                <Row>
                    {/* <Col sm={12} md={6} lg={6}>
                        <div>
                            <Image src={BannerImag} alt="Ring Banner Image" className="img-fluid" />
                        </div>
                    </Col> */}
                    <Col sm={12} md={12} lg={5} className="dfl_eng_box">
                        <Image src={BannerImag} alt="Ring Banner Image" className="img-fluid dfl_eng_ribg_d_none_desktop" />
                        <div>
                            <div className="eng-box2 text-center box-design">
                                <div className="title-box4 text-center">
                                    <h1 className="title32">Engagement Rings</h1>
                                    <img src={LineImg} alt="line 1" />
                                </div>
                                <p className="both-pr">Planning a proposal? Take a look at our wide selection of loose diamonds and engagement rings. You can shop online or browse our instore selection at our location in Woodstock, GA. </p>
                                {/* <p className="both-pr">Browse through our 1000’s of styles from the latest designs to timeless classics, then choose your loose diamond and allow our experts create the Engagement Ring of your dreams</p> */}
                                <div className="eng-btn pt-0">
                                    <ul>
                                        <li> <NavLink to="#"> <img src={IconImg1} alt="ring shap" /> </NavLink> </li>
                                        <li>+ </li>
                                        <li> <NavLink to="#"> <img src={IconImg2} alt="diamond" /> </NavLink> </li>
                                        <li>= </li>
                                        <li> <img src={IconImg3} alt="complete ring" />  </li>
                                    </ul>
                                    <Row className="btn-wrapper text-uppercase text-center pt-4">
                                        <Col xs={12} sm={12} md={6} lg={6} className='pl-0'> <NavLink className="btn-engage" to="/ringsettings"> ENGAGEMENT RINGS </NavLink> </Col>
                                        <Col xs={12} sm={12} md={6} lg={6} className='pl-0' >  <NavLink className="btn-engage" to="/diamonds"> LOOSE DIAMONDS </NavLink> </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default EngagementRings